<div class="grid grid-cols-2 gap-6 align-items-center">
  <div>
      <h4 i18n="@@translateApp_targetSelection_sourceText">Source text</h4>
      <p>{{ sourceCultureFriendlyName }}</p>
  </div>
  <div>
  <h4 i18n="@@translateApp_targetSelection_translation">Translation</h4>
    <xena-select (valueChange)="select($event)"
      placeholder="Select the language you will translate to"
      i18n-placeholder="@@translateApp_targetSelection_selectPlaceholder"
    >
      <xena-menu-label *ngIf="usedCultures.length"
        i18n="@@translateApp_targetSelection_selectLabelTranslated">Translated</xena-menu-label>
      <xena-menu-item *ngFor="let c of usedCultures" [value]="c.culture">{{ c.name }}</xena-menu-item>
      <xena-menu-divider *ngIf="unusedCultures.length && usedCultures.length"></xena-menu-divider>
      <xena-menu-label *ngIf="unusedCultures.length"
        i18n="@@translateApp_targetSelection_selectLabelNotTranslated">Not translated</xena-menu-label>
      <xena-menu-item *ngFor="let c of unusedCultures" [value]="c.culture">{{ c.name }}</xena-menu-item>
    </xena-select>
  </div>
</div>
